import { createClient } from '@/shared/api';
import type { StudyLogsQuery, StudyLogsQueryVariables } from '@/shared/api';
import STUDY_LOGS_QUERY from '../queries/studyLogs';

/**
 * Loads the audit log entries recorded against a study. Runs STUDY_LOGS_QUERY and falls back to an empty array when the response carries no studyLogs.
 *
 * @param studyId - Identifier of the study whose logs are read.
 * @returns The study log entries, or an empty array.
 */
const fetchStudyLogs = async (studyId: any) => {
  const client = createClient();
  const result = await client.query<StudyLogsQuery, StudyLogsQueryVariables>({
    query: STUDY_LOGS_QUERY,
    variables: {
      studyId,
    },
  });
  return result?.data?.studyLogs || [];
};

export default fetchStudyLogs;
